import axios from 'axios';
import React, { useState } from "react";
import Cookies from 'js-cookie';

export default function useData({ q, dependency, t, apiUrl, skip = false }: { q?: string, dependency: any[], t?: string, apiUrl: string, skip?: boolean }) {
    const [fetchedData, setData] = React.useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any | null>(null);

    React.useEffect(() => {
        if (skip || !q || q.trim() === '') return;

        const fetchData = async () => {
            try {
                setLoading(true)
                const phone = '';
                const licence_id = localStorage.getItem('licence_id');
                // const sessionId = await localStorage.getItem('sessionId')
                const sessionId = Cookies.get('sessionId');

                const response = await axios.post(
                    `${apiUrl}`,
                    { q },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: {
                            t,
                            phone,
                            id: licence_id,
                            s: sessionId
                        },
                    }
                );
                setData(response.data || []);
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                    setError(error || 'Request Failed');
                }
            } finally {
                setLoading(false);
            }
        };

        void fetchData();
    }, dependency);
    return { fetchedData, loading, error };
}